<template>
    <div >
        
    </div>
</template>
<script>
export default {
  data() {
    return {
        code:this.$route.query.code?this.$route.query.code:'',
        state:this.$route.query.state?this.$route.query.state:''
    };
  }, 
  
  created() {


   

        const url = `/bbs/qq?code=${this.code}&state=${this.state}`;
        window.location = url;


  },
 
};
</script>
<style scoped>

</style>